var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/password"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.646 9.183v7.415m7.686-.916 1.354-1.342 2.034 1.395 1.645-2.007 1.718 2.06c1.61.025 2.943-1.33 2.917-3.026-.027-1.696-1.306-3.092-2.917-3.117L10.23 9.51v-.44c-.042-2.665-2.052-4.857-4.584-4.897-2.53-.039-4.688 2.09-4.645 4.756v7.897c.042 2.665 2.114 4.858 4.645 4.898 2.532.039 4.626-2.09 4.584-4.756v-1.316l3.102.03Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.1f49aaecb60b89a3d42bf544c85b9dc8.svg";
export { ForwardRef as ReactComponent };